import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

const Logo = ({ to = '/', width = '120px', height = '40px', src = '/assets/logo.svg' }) => {
  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Box
        sx={{
          width,
          height,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          transition: 'opacity 0.3s',
          '&:hover': {
            opacity: 0.8,
          },
        }}
      >
        <img src={src} alt="pitch+ Logo" style={{ width: '100%', height: 'auto' }} />
      </Box>
    </Link>
  );
};

Logo.propTypes = {
  to: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  src: PropTypes.string,
};

export default Logo;
